// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__GEbvz","title":"Editor_title__bbRHn","inputBlock":"Editor_inputBlock__+I1dR","outputBlock":"Editor_outputBlock__Se3p0"};